import { useState } from 'react';

import { Color } from '@/constants/color';
import Button from '@/ui/components/Button';
import DatetimePicker from '@/ui/components/Form/DatetimePicker';
import Spinner from '@/ui/components/Spinner';

import { Props } from './types';

const TaskDueDate = ({ itemId, dueDate: initialDueDate, updateItem }: Props) => {
  const [dueDate, setDueDate] = useState<string | null>(initialDueDate);

  const handleChange = (date: Date | null) => {
    setDueDate(date?.toISOString() ?? null);
  };

  const { isPending, mutate } = updateItem;

  const saveDueDate = () => {
    mutate({
      id: itemId,
      values: {
        due_at: dueDate
      }
    });
  };

  return (
    <div>
      <div className="mb-2 w-48">
        <DatetimePicker
          label="Due Date"
          name="datetime-modify-due-date"
          onChange={handleChange}
          placement="top-start"
          value={dueDate}
        />
      </div>

      <Button color={Color.GREEN} disabled={isPending} onClick={saveDueDate}>
        {isPending ? <Spinner /> : 'Save Due Date'}
      </Button>
    </div>
  );
};

export default TaskDueDate;
